// extracted by mini-css-extract-plugin
module.exports = {"switchRoomsImage":"SwitchRooms_switchRoomsImage__3W7Mm","closeDiv":"SwitchRooms_closeDiv__19rHy"};